module.exports = __webpack_public_path__ + "img/project_icon_eight.e9a2641f.png";